import styled from 'styled-components';

export const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 2;

  @media (max-width: 970px) {
    flex-direction: row;
    left: 20px;
    right: auto;
  }
`;

export const Button = styled.a`
  background: #fff url('/public-assets/images/interactive-floorplan/plus.svg')
    center center no-repeat;
  background-size: 18px auto;
  border-radius: 3px;
  border: 0;
  color: #1277c6;
  cursor: pointer;
  font-size: 18px;
  display: block;
  height: 36px;
  overflow: hidden;
  margin-bottom: 8px;
  text-indent: -1000em;
  width: 36px;

  &.is-disabled {
    cursor: default;
    opacity: 0.5;
  }

  :last-of-type {
    background-image: url('/public-assets/images/interactive-floorplan/minus.svg');
    background-size: 22px auto;
    font-size: 24px;
    margin-bottom: 0;
  }

  @media (max-width: 970px) {
    margin-bottom: 0;
    margin-right: 8px;

    :last-of-type {
      margin-right: 0;
    }
  }
`;
